<template>
  <section class="metric-card">
    <header class="metric-card__header">
      <h3>{{ report.title }}</h3>
      <span class="metric-card__total"><i></i>{{ formatNumber(report.total) }} lỗi</span>
    </header>

    <div class="metric-card__stats">
      <div v-for="item in statItems" :key="item.key" class="stat-box"
        :class="item.passed ? 'stat-box--passed' : 'stat-box--failed'">
        <div class="stat-box__top">
          <strong>{{ formatRate(item.rate) }}</strong>
          <span>{{ item.passed ? 'Đạt' : 'Chưa đạt' }}</span>
        </div>
        <div class="stat-box__form">{{ item.label }}</div>
        <div class="stat-box__count">{{ formatNumber(item.total) }}</div>
        <dl>
          <div>
            <dt>Admin</dt>
            <dd>{{ formatNumber(item.admin) }}</dd>
          </div>
          <div>
            <dt>Khác</dt>
            <dd>{{ formatNumber(item.other) }}</dd>
          </div>
        </dl>
      </div>
    </div>

    <div class="metric-card__activity">
      <h4 class="activity-title">
        <i class="el-icon-time"></i>
        <span>ACTIVITY LOG</span>
      </h4>
      <div class="activity-list">
        <div v-for="(activity, index) in report.activities" :key="index" class="activity-row">
          <span class="activity-row__form">{{ activity.exam_form }}</span>
          <span class="activity-row__name" :title="activity.name">{{ activity.name }}</span>
          <span class="activity-row__count">{{ formatNumber(activity.count) }} lượt</span>
        </div>
        <div v-if="!report.activities.length" class="activity-empty">Không có hoạt động nào</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ViolationMetricCard',
  props: {
    report: {
      type: Object,
      required: true
    }
  },
  computed: {
    statItems() {
      return [
        { ...this.report.online, key: 'online', label: 'ONLINE' },
        { ...this.report.offline, key: 'offline', label: 'OFFLINE' }
      ];
    }
  },
  methods: {
    formatNumber(value) {
      return Number(value || 0).toLocaleString('vi-VN');
    },
    formatRate(value) {
      return `${value || 0}%`;
    }
  }
};
</script>

<style scoped lang="scss" src="./ViolationMetricCard.scss"></style>
